/**
 * Main entry point — Safety Rail Source
 * Initializes all section modules.
 */

document.addEventListener('DOMContentLoaded', function () {
  // Global utilities (always loaded via utils.js + this file)
  if (typeof initScrollReveal       === 'function') initScrollReveal();
  if (typeof initLazyLoad           === 'function') initLazyLoad();
  if (typeof initEPrefixCasing      === 'function') initEPrefixCasing();
  if (typeof initSearchResultsPage  === 'function') initSearchResultsPage();
  initTrademarkSupClasses();
  initVimotiaAltFix();

  // Section behaviors — each function lives in its own section JS file
  // (e.g. initAccordions → section-services.js, initCarousel →
  // section-reviews.js, initNewsletterForm → section-newsletter.js).
  // Those files are only included on pages that render the section, so
  // on other pages the function is undefined. Guard each call so a
  // missing per-section script can't break the rest of the chain.
  if (typeof initAccordions     === 'function') initAccordions();
  if (typeof initCarousel       === 'function') initCarousel();
  if (typeof initNewsletterForm === 'function') initNewsletterForm();
});

/**
 * Trademark / registered superscript classifier.
 * Catches any <sup>®</sup> / <sup>™</sup> not already wrapped with
 * rmark / tmark (admin rich text, third-party widgets, etc.) and
 * assigns the right class so the global rules in base.css render
 * them at consistent visual size. Idempotent — re-classifies new
 * DOM via MutationObserver for live-injected content.
 */
function initTrademarkSupClasses() {
  function classify(root) {
    if (!root || !root.querySelectorAll) return;
    var sups = root.querySelectorAll('sup:not(.tmark):not(.rmark)');
    for (var i = 0; i < sups.length; i++) {
      var t = (sups[i].textContent || '').trim();
      if (t === '®') sups[i].classList.add('rmark');         // ®
      else if (t === '™') sups[i].classList.add('tmark');    // ™
    }
  }
  classify(document);
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) classify(added[j]);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
}

/**
 * Vimotia video thumbnail alt fix.
 * The Hextom Vimotia app injects its video thumbnail at runtime:
 *   <img class="vimotia__video-wrapper__background" src="...">
 * That element isn't in the theme, so the alt can't be set in Liquid.
 * This watches the DOM and sets a descriptive alt once the app renders
 * the image. Idempotent — re-applies to live-injected content.
 */
function initVimotiaAltFix() {
  var ALT = 'about-us';
  var SELECTOR = 'img.vimotia__video-wrapper__background';

  function applyAlt(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('alt') !== ALT) imgs[i].setAttribute('alt', ALT);
    }
  }

  applyAlt(document);
  var mo = new MutationObserver(function () { applyAlt(document); });
  mo.observe(document.body, { childList: true, subtree: true });
}
